import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminDashboard from './AdminDashboard';
import CaseStudyPage from './components/CaseStudyPage';
import CityFocusPage from './components/CityFocusPage';
import LocationServicesPage from './components/LocationServicesPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/case-study/:slug" element={<CaseStudyPage />} />
            <Route path="/react-architecture-:city" element={<CityFocusPage categoryKey="react-architecture" />} />
            <Route path="/ui-ux-design-:city" element={<CityFocusPage categoryKey="ui-ux-design" />} />
            <Route path="/digital-strategy-:city" element={<CityFocusPage categoryKey="digital-strategy" />} />
            <Route path="/location-services/:service/:city" element={<LocationServicesPage />} />
            <Route path="/digital-strategy/:city" element={<LocationServicesPage defaultService="digital-strategy" />} />
            <Route path="/react-architecture/:city" element={<LocationServicesPage defaultService="react-architecture" />} />
            <Route path="/ui-ux-design/:city" element={<LocationServicesPage defaultService="ui-ux-design" />} />
            <Route path="/:service/:city" element={<LocationServicesPage />} />
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);